import * as React from "react";
import { forwardRef } from "react";
const SvgKeyboardArrowUp = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6.175 12.8417L10 9.02499L13.825 12.8417L15 11.6667L10 6.66666L5 11.6667L6.175 12.8417Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgKeyboardArrowUp);
export default ForwardRef;
